import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { AlertService } from '../../../services/common/alert.service';
import { MatterService } from '../../../services/matters/matter.service';

@Component({
  selector: 'app-matter-tags',
  templateUrl: './matter-tags.component.html',
  styleUrls: ['./matter-tags.component.css'],
})
export class MatterTagsComponent implements OnInit, OnChanges {
  @Input() matter_id: number;

  newTag: string | null;

  tags: Array<string> = [];

  tags_loading: boolean = true;

  showNewTagForm: boolean = false;

  constructor(private alertService: AlertService, private matterService: MatterService) {}

  // Component lifecycle events
  ngOnInit() {
    if (this.matter_id) this.loadTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue) this.loadTags();
  }

  // Component methods
  loadTags() {
    this.matterService.getTags(this.matter_id).then((response_json) => {
      this.tags = response_json;
      this.tags_loading = false;
    });
  }

  addTag() {
    if (this.newTag)
      this.matterService
        .addTag(this.matter_id, this.newTag)
        .then((response_json) => {
          if (response_json.text == 'Tag added') {
            this.alertService.alert_status_success(response_json.text);
            this.newTag = null;
          } else this.alertService.alert_status_danger('Error adding tag');
          this.loadTags();
          this.showNewTagForm = false;
        })
        .catch(() => {
          this.alertService.alert_status_danger('Error adding tag');
        });
    else this.alertService.alert_status_warning('Please enter the new tag');
  }

  removeTag(index: number) {
    this.matterService
      .removeTag(this.matter_id, this.tags[index])
      .then((response_json) => {
        if (response_json.text == 'Tag removed') this.alertService.alert_status_success(response_json.text);
        else this.alertService.alert_status_danger('Error removing tag');
        this.loadTags();
      })
      .catch(() => {
        this.alertService.alert_status_danger('Error removing tag');
      });
  }
}
